export var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["TaskBoardContainer_OpenTaskIdsArray"] = "TaskBoardContainer_OpenTaskIdsArray";
    LocalStorageKey["MyTasksWidgetWhereICanStart"] = "MyTasksWidget_WhereICanStart";
    LocalStorageKey["MyTasksWidgetConfiguredKpis"] = "MyTasksWidget_ConfiguredKpis";
})(LocalStorageKey || (LocalStorageKey = {}));
export const setLocalStorageItem = (key, value) => {
    localStorage.setItem(key.toString(), JSON.stringify(value));
};
export const getLocalStorageItem = (key, defaultValue) => {
    const value = localStorage.getItem(key.toString());
    if (value)
        return JSON.parse(value);
    return defaultValue || undefined;
};
